import { Button } from "@hoylu/client-common";
import React from "react";
import { useDispatch } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import { activateDashboardOption } from "../../state/workspaces/workspaces.actions";
import Styles from "./HeaderButtons.module.css";

type LocalizationDict = {
  open: {
    text: string;
    tooltip: string;
  };
  invite: {
    text: string;
    tooltip: string;
  };
};

type HeaderButtonsProps = {
  showSearch: boolean;
  handleSearchClick: () => void;
  localizationDict: LocalizationDict;
};

export const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  showSearch,
  handleSearchClick,
  localizationDict,
}) => {
  const dispatch = useDispatch();

  const invite = () =>
    dispatch(
      activateDashboardOption({
        optionType: DashboardOption.INVITE,
      }),
    );

  return (
    <section className={Styles.buttonsContainer} tabIndex={0}>
      {showSearch && (
        <Button
          classNames={[Styles.headerButton]}
          dataTestId="Open shared workspace"
          onClick={handleSearchClick}
          toolTip={localizationDict.open.tooltip}
          type="blackAndWhite"
        >
          {localizationDict.open.text}
        </Button>
      )}
      <Button
        classNames={[Styles.headerButton]}
        dataTestId="Invite users"
        onClick={invite}
        toolTip={localizationDict.invite.tooltip}
        type="blackAndWhite"
      >
        {localizationDict.invite.text}
      </Button>
    </section>
  );
};

export default HeaderButtons;
